"use client";

import { SkeletonLine, SkeletonStack } from "@health/ui";

/**
 * Loading skeleton mirroring ConsentForm — state label + underlined select,
 * with no consent text or button (those only appear after a state is
 * picked).
 *
 * Lives in its own file so {@link WidgetLoadingRegistry} can import it
 * without pulling in the lazy-loaded {@link TelehealthConsentWidget} chunk.
 */
export function TelehealthConsentWidgetSkeleton() {
  return (
    <div className="flex flex-col gap-3 w-full sm:max-w-md mt-3">
      <SkeletonStack className="gap-2">
        <SkeletonLine $size="text" $width="md" />
        <div className="border-b border-border pb-2">
          <SkeletonLine $size="text" $width="lg" />
        </div>
      </SkeletonStack>
    </div>
  );
}
